import { render } from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=template&id=2cb47528"
import script from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=script&lang=js"
export * from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__